'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _propTypes2.default.shape({
  spotsTaxonomyLocation: _propTypes2.default.string,
  forecastsTaxonomyLocation: _propTypes2.default.string
});


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/PropTypes/navigationSettingsPropType.js
// module id = 93
// module chunks = 0